<!--
 * @Author:
 * @Description: 新增缺陷
-->
<template>
  <CockpitDialog
    :title="title"
    class="left-550px top-240px text-white !text-opacity-80"
    @close="close"
  >
    <iframe class="w-full h-full" ref="iframe" :src="iframeUrl" :loading="tableLoading"></iframe>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  name: 'defectForm',
  components: {
    CockpitDialog,
  },
  props: {},
  data() {
    return {
      title: '新增缺陷',
      account: '',
      iframeUrl: '',
      tableLoading: false,
    }
  },
  computed: {
    // 驾驶舱配置
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-cockpit'].config
    },
    newDefectUrl() {
      return this.modelSetting.defectManageConfig?.newDefectUrl || null
    },
  },
  created() {
    this.account = Wiz.AuthHooks.GetUserInfo().profile.name
    this.getIframeUrl()
  },
  methods: {
    close() {
      this.$emit('refresh', false)
    },
    // 获取单点登录地址
    async getIframeUrl() {
      this.tableLoading = true
      axios({
        method: 'GET',
        url: `${this.newDefectUrl}?account=${this.account}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res, '获取iframe地址')
          this.tableLoading = false
          this.iframeUrl = res
        })
        .catch((err) => {
          this.tableLoading = false
          console.log(err)
        })
    },
    // 获取iframe内容,给src重新赋值
    getIframeContent() {
      const iframe = this.$refs.iframe
      if (iframe.contentWindow) {
        const iframeBody = iframe.contentWindow.document.body
        const iframeContent = iframeBody.innerText
        console.log(iframeContent, '获取内容打印结果')
        iframe.src = iframeContent
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
